<ng-container *ngIf="visible$ | async">
  <div class="custom-product-image">
    <a
      *ngIf="link(); else image"
      data-testing-id="product-image-link"
      [routerLink]="linkTarget() || (productURL$ | async)"
      [queryParamsHandling]="computedQueryParamsHandling"
      tabindex="-1"
      ><ng-container *ngTemplateOutlet="image" />
    </a>
  </div>

  <ng-template #image>
    <ng-container *ngIf="productImage$ | async as image; else noImage">
      <ng-container *ngIf="lensShow(); else noZoom">
        <div
          class="image-zoom-container"
          appImageZoomMagnifier
          [imgSrc]="image.effectiveUrl"
          [zoomRatio]="3"
          [zoomWindowElementRef]="zoomWindowElement()"
        >
          <img
            *ngIf="image.effectiveUrl; else noImage"
            [attr.loading]="loading()"
            class="product-image"
            [src]="image.effectiveUrl"
            [alt]="altText() || (defaultAltText$ | async)"
            itemprop="image"
            #imageRef
          />
          <!-- <div class="lens" *ngIf="zoomVisible" [ngStyle]="lensStyle">
          <div class="zoom" [ngStyle]="zoomStyle"></div>
        </div> -->
        </div>
      </ng-container>

      <ng-template #noZoom>
        <img
          *ngIf="image.effectiveUrl; else noImage"
          loading="lazy"
          class="product-image"
          [src]="image.effectiveUrl"
          [attr.alt]="altText() || (defaultAltText$ | async)"
          itemprop="image"
          #imageRef
          (click)="viewItemGTMEvent()"
        />
      </ng-template>
    </ng-container>

    <ng-template #noImage>
      <img
        [attr.loading]="loading()"
        src="/assets/img/not-available.svg"
        [alt]="'product.image.not_available.alttext' | translate"
      />
    </ng-template>
  </ng-template>
</ng-container>
